"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConstitutableMiddleware = void 0;
// @ts-ignore
const constitute_1 = require("constitute");
const inversify_1 = require("inversify");
const getConstitutableMiddleware = (container) => (planAndResolve) => ((params) => {
    const { serviceIdentifier } = params;
    // Gets dependencies decorated with @inject decorator
    const getClientInjectableMetadata = (serviceIdentifier) => (serviceIdentifier instanceof Object
        ? Object.values(Reflect.getMetadata(inversify_1.METADATA_KEY.TAGGED, serviceIdentifier) || {})
        : []);
    // Checks whether dependency is already bound to inversify container or can be bound to inversify container
    const isInjectable = (serviceIdentifier) => (container.isBound(serviceIdentifier) || (serviceIdentifier instanceof Object && Reflect.hasOwnMetadata(inversify_1.METADATA_KEY.PARAM_TYPES, serviceIdentifier)));
    // Makes inversify dependency constitutable
    const constitutable = (serviceIdentifier) => (new constitute_1.InstanceResolver(isInjectable(serviceIdentifier) ? new constitute_1.Value(container.get(serviceIdentifier)) : serviceIdentifier));
    // First Step: Make injectable all Service Identifier’s dependencies decorated with @inject decorator
    (function decorateInjectable(serviceIdentifier) {
        getClientInjectableMetadata(serviceIdentifier).forEach((dependencies) => (dependencies.forEach((dependency) => {
            decorateInjectable(dependency.value);
            if (!isInjectable(dependency.value)) {
                container.bind(dependency.value).toDynamicValue(({ container }) => {
                    return container.constituteContainer.constitute(dependency.value);
                }).inTransientScope();
            }
        })));
    }(serviceIdentifier));
    // Second Step: If Service Identifier is not injectable - resolve dependencies in @Dependencies decorator and
    // in constructor (make it all constitutable), bind to inversify container as Dynamic Value and
    // finally constitute Service Identifier.
    if (!isInjectable(serviceIdentifier)) {
        container.bind(serviceIdentifier).toDynamicValue(({ container }) => {
            const decoratedServiceIdentifier = (function decorateConstitutable(serviceIdentifier) {
                const decorateConstituteDependency = (dependency) => ((dependency === null || dependency === void 0 ? void 0 : dependency.key) ? constitutable(decorateConstitutable(dependency.key)) : dependency);
                const decorateInversifyDependency = (dependency) => ((dependency === null || dependency === void 0 ? void 0 : dependency.value) ? constitutable(decorateConstitutable(dependency.value)) : dependency === null || dependency === void 0 ? void 0 : dependency.value);
                if (serviceIdentifier.constitutor) {
                    serviceIdentifier.constitutor.constituents.map(decorateConstituteDependency);
                }
                if (serviceIdentifier.constitute) {
                    serviceIdentifier.constitute.constituents.map(decorateConstituteDependency);
                    getClientInjectableMetadata(serviceIdentifier).flat().forEach((dependency) => {
                        serviceIdentifier.constitute.constituents.push(decorateInversifyDependency(dependency));
                    });
                }
                return serviceIdentifier;
            }(serviceIdentifier));
            return container.constituteContainer.constitute(decoratedServiceIdentifier);
        }).inTransientScope();
    }
    return planAndResolve(params);
});
exports.getConstitutableMiddleware = getConstitutableMiddleware;
//# sourceMappingURL=getConstitutableMiddleware.js.map